// Admin API. Methods are bound to the shared ApiClient instance
// via Object.assign in src/utils/api.js.
export function createAdminApi(client) {
  return {
    async getUsers() {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'getUsers' })
      })
      return { data: result.data, error: null }
    },

    async updateUserRole(id, role) {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'updateUserRole', id, role })
      })
      return { error: null }
    },

    async setUserPlan(userId, plan) {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'setUserPlan', userId, plan })
      })
      return result
    }
  }
}
